import { render, staticRenderFns } from "./AamsRegSealAnnualRecord.vue?vue&type=template&id=229da44c&scoped=true&"
import script from "./AamsRegSealAnnualRecord.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealAnnualRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229da44c",
  null
  
)

export default component.exports